if (!customElements.get('yumore-footer')) {
  customElements.define('yumore-footer', class extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.yf__group'));
      this.media = window.matchMedia('(min-width: 750px)');
      this.sync = () => {
        this.groups.forEach((group) => {
          group.open = this.media.matches;
          const summary = group.querySelector('summary');
          if (this.media.matches) summary.setAttribute('tabindex', '-1');
          else summary.removeAttribute('tabindex');
        });
      };
      this.sync();
      this.media.addEventListener('change', this.sync);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.sync);
    }
  });
}
